// @ts-nocheck
import React from 'react';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import SortableItem from './SortableItem';

const SortableList = ({
  items,
  allColumns,
  onSortEnd,
  onColumnChange,
  onColumnDelete,
}) => {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      const oldIndex = items.findIndex(
        (item) => `item-${item.id}` === active.id
      );
      const newIndex = items.findIndex((item) => `item-${item.id}` === over.id);

      onSortEnd({
        oldIndex,
        newIndex,
      });
    }
  };

  return (
    <ol className="sortable-container">
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={items.map((item) => `item-${item.id}`)}
          strategy={verticalListSortingStrategy}
        >
          {items.map((column) => (
            <SortableItem
              key={`item-${column.id}`}
              id={`item-${column.id}`}
              column={column}
              items={items}
              allColumns={allColumns}
              onColumnChange={onColumnChange}
              onColumnDelete={onColumnDelete}
            />
          ))}
        </SortableContext>
      </DndContext>
    </ol>
  );
};



export default SortableList;
